import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import ActivityIcon from 'apps/auth/components/ga/activity/components/ActivityIcon';
import ActivityStatus from 'apps/auth/components/ga/activity/components/ActivityStatus';
import ActivityTitle from 'apps/auth/components/ga/activity/components/ActivityTitle';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { CASH_DELIVERY, CASH_PICKUP, INTERAC } from 'apps/auth/constants/GaConstants';
import { USA, VIETNAM } from 'apps/auth/constants/WellKnownCountries';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { useApp, useLanguage } from 'apps/auth/hooks/selectors';

const GaCheckHeader = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, stsId, failedCheque } = props.options;
    const { country } = useApp();
    const { lang } = useLanguage();

    const isUsaUser = () => {
        return props.userCountryId === USA;
    };

    const getAmount = () => {
        const fromCurrency = mobileInfo.frCurIso && typeof mobileInfo.frCurIso === 'string' ? mobileInfo.frCurIso.toLowerCase() : '';
        const toCurrency = mobileInfo.toCurIso && typeof mobileInfo.toCurIso === 'string' ? mobileInfo.toCurIso.toLowerCase() : '';
        return (
            <>
                <Text size="header" color={textColor} ellipsis lineThrough={failedCheque}>
                    {`${getLocalizedRawAmount(lang, country, item.frAmtReal)} `}
                    <Text size="header" smallCaps color={textColor}>
                        {fromCurrency}
                    </Text>
                </Text>
                {mobileInfo?.curRate !== 1 && (
                    <>
                        <Text size="header" color={textColor}>
                            {' → '}
                        </Text>
                        <Text size="header" color={textColor} ellipsis lineThrough={failedCheque}>
                            {`${getLocalizedRawAmount(lang, country, item.toAmtReal)}`}
                            <Text size="header" smallCaps color={textColor}>
                                {toCurrency}
                            </Text>
                        </Text>
                    </>
                )}
            </>
        );
    };

    const getStatusText = () => {
        let statusText = mobileInfo.stsName;
        if (stsId < STATUS_OK && mobileInfo.icon === INTERAC && mobileInfo.extraFields.transactionCode) {
            statusText = props.chequeInteracStatusInProgress;
        } else if (stsId < STATUS_OK && mobileInfo.icon === CASH_PICKUP && mobileInfo.extraFields.transactionCode) {
            statusText = props.chequeCashStatusInProgress;
            if (item.toCountryId === VIETNAM && !item.vietcombank) {
                statusText = props.chequeCashStatusNotVietcombankInProgress;
            }
        } else if (stsId > 10 && stsId < STATUS_OK && mobileInfo.icon === CASH_DELIVERY) {
            statusText = props.chequeHomeDeliveryStatusInProgress;
        } else if (stsId === STATUS_OK && mobileInfo.icon === INTERAC) {
            statusText = props.chequeInteracStatusSuccess;
        } else if (stsId === STATUS_OK && (mobileInfo.icon === CASH_DELIVERY || mobileInfo.icon === CASH_PICKUP)) {
            statusText = props.chequeHomeDeliveryStatusSuccess;
        } else if (stsId < STATUS_OK && mobileInfo.icon === INTERAC) {
            statusText = props.chequeFromInteracStatusInProgress;
            // <c:set var="cssClassStatus" value="sending"/>
        } else if (stsId === STATUS_OK) {
            statusText = props.chequeStatusSuccess;
            // <c:set var="cssClassStatus" value="success"/>
        } else if (stsId > STATUS_OK) {
            statusText = props.chequeStatusError;
        } else if (stsId > 10 && stsId < STATUS_OK) {
            statusText = props.chequeStatusInProgress;
        }
        return statusText;
    };

    const getSpecialStatus = () => {
        let statusMessage;

        if (stsId <= 10 || stsId > STATUS_OK) {
            statusMessage = mobileInfo.errorMessage;
        } else if (stsId > 10 && stsId < STATUS_OK && mobileInfo.icon === INTERAC && !mobileInfo.extraFields.transactionCode) {
            statusMessage = props.chequeInteracStatusSpecialInfo;
        } else if (stsId > 10 && stsId < STATUS_OK && mobileInfo.icon === CASH_PICKUP && !mobileInfo.extraFields.transactionCode) {
            statusMessage = props.chequeCashStatusInSending;
        }
        if (statusMessage) {
            return <DangerouslyHtml dangerouslyHtml={statusMessage} />;
        }
    };

    const getStatusIcon = () => {
        if (stsId >= 10 && stsId < STATUS_OK) {
            return 'clock';
        } else if (stsId === STATUS_OK) {
            return 'check';
        } else {
            return 'cross-rounded';
        }
    };

    return (
        <>
            {isUsaUser() && (
                <Text variant="div" size="secondary" indent="adaptive-24-32">
                    {props.chequeUsaNotReceipt}
                </Text>
            )}
            <Row indent="adaptive-16-24">
                <ActivityIcon item={item} options={props.options} flagName={item.toCountryISO?.toLowerCase()} />
            </Row>
            <ActivityTitle message={mobileInfo.title} color={textColor} />
            <Row indent="adaptive-24-32">
                {getAmount()}
                {item.payComment && (
                    <Text variant="paragraph" ellipsis color="secondary">
                        {item.payComment}
                    </Text>
                )}
            </Row>
            <Row indent={mobileInfo.errorMessage ? 'adaptive-16-24' : null}>
                <ActivityStatus isShowStatus status={stsId} text={getStatusText()} isUseExternalIconName externalGetIconName={getStatusIcon} />
            </Row>
            {getSpecialStatus()}
        </>
    );
};

const mapStateToProps = (state) => ({
    userCountryId: state.auth.countryId,
    chequeStatusInProgress: state.messages.pageMessages.chequeStatusInProgress,
    chequeFromInteracStatusInProgress: state.messages.pageMessages.chequeFromInteracStatusInProgress,
    chequeStatusSuccess: state.messages.pageMessages.chequeStatusSuccess,
    chequeStatusError: state.messages.pageMessages.chequeStatusError,
    chequeInteracStatusSuccess: state.messages.pageMessages.chequeInteracStatusSuccess,
    chequeInteracStatusInProgress: state.messages.pageMessages.chequeInteracStatusInProgress,
    chequeCashStatusInProgress: state.messages.pageMessages.chequeCashStatusInProgress,
    chequeHomeDeliveryStatusSuccess: state.messages.pageMessages.chequeHomeDeliveryStatusSuccess,
    chequeHomeDeliveryStatusInProgress: state.messages.pageMessages.chequeHomeDeliveryStatusInProgress,
    chequeCashStatusNotVietcombankInProgress: state.messages.pageMessages.chequeCashStatusNotVietcombankInProgress,
    chequeInteracStatusSpecialInfo: state.messages.pageMessages.chequeInteracStatusSpecialInfo,
    chequeCashStatusInSending: state.messages.pageMessages.chequeCashStatusInSending,
});

export default connect(mapStateToProps)(GaCheckHeader);
